<rask-container-block>
  <ng-container header>
    <rask-header size="2" underline>{{ 'TPL_SOK_HEADER' | translate }}</rask-header>
  </ng-container>
  @if (validationContext) {
    <form [formGroup]="form" (ngSubmit)="search()" autocomplete="off">
      <rask-tree-selector
        class="form-group w-100"
        [label]="'TPL_SOK_GEOGRAFI' | translate"
        [items]="marknadsomraden"
        [required]="true"
        (change)="produktionsomradeChanged()"
        [raskRule]="validationContext.current.produktionsomradeIdList">
      </rask-tree-selector>
      <rask-radiobutton-group
        label="{{ 'TPL_SOK_TRANSPORTSATT' | translate }}"
        [buttons]="transportsatt"
        formControlName="transportsatt">
      </rask-radiobutton-group>
      @if (form.value.transportsatt === 'Bränsle') {
        <rask-radiobutton-group
          label="{{ 'TPL_SOK_PERIODTYP' | translate }}"
          [buttons]="periodtypes"
          class="timesplantype"
          formControlName="periodType"
          >
        </rask-radiobutton-group>
      }
      <div style="clear:both"></div>
      <rask-datepicker
        formControlName="periodFrom"
        [label]="getTidspanText()"
        [minDate]=""
        [onlyMonths]="false"
        class="date">
      </rask-datepicker>
      <span class="periodBinder">-</span>
      <rask-datepicker
        formControlName="periodTom"
        [minDate]=""
        [onlyMonths]="false"
        class="date">
      </rask-datepicker>
      <div class="period-btn-container">
        <rask-button color="secondary" (click)="addMonth()"><i class="fal fa-plus"></i>
      {{ 'TPL_SOK_ENMANAD' | translate }}</rask-button>
      <rask-button class="right-btn ps-1" color="secondary" (click)="addQuarter()"><i class="fal fa-plus"></i>
    {{ 'TPL_SOK_ETTKVARTAL' | translate }}</rask-button>
  </div>
  <ng-container footer>
    <rask-submit-button aid="tplSokArbetsorder" color="primary">
      {{ 'DEFAULT_BUTTON_LABEL_SOK' | translate }}
    </rask-submit-button>
    @if (noSearchResults) {
      <label>{{ 'TPL_SOK_INGA_ARBETSORDRAR' | translate }}</label>
    }
  </ng-container>
</form>
}

</rask-container-block>